import React from 'react'

// store
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
// actions
import * as USER_ACTION from '@store/user/actions'
import * as SHARED_ACTION from '@store/shared/actions'

import { Modal, Icon } from '@components/shared/elements'
import MaskedInput from 'react-text-mask'

import TOOLS from '@helpers/tools'
import COOKIES from '@helpers/cookies'
import { handleBlurDatalayer, genericModalDataLayer } from '@helpers/BI'
import slugify from 'slugify'
import { isEqual, isEmpty } from 'lodash'

import './ModalStyle.scss'

class ModalEmail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      email: '',
      phone: '',
      shBranchId: '',
      shBranchName: '',
      shBranchModalId: '',
      stateInitials: '',
      whatsapp: false,
      nameDirt: false,
      emailDirt: false,
      phoneDirt: false,
      blockSending: false,
      success: '',
      error: '',
      hasBranches: false,
      branchSelected: '',
      hasFacilitaMsg: '',
      privacyPolicies: true,
      hasListaFiliais: false,
      singleFilial: false,
      listaFiliaisAtendimento: [],
      zoneName: '',
    }
    this.el = React.createRef()
  }

  componentDidMount() {
    let reduxUser = this.props.currentUser
    if (!isEmpty(reduxUser)) {
      this.setState({
        nameDirt: true,
        name: reduxUser.Nome,
        emailDirt: true,
        email: reduxUser.Email,
        phoneDirt: true,
        phone: reduxUser.Telefone,
      })
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.shBranchId === '') {
      if (prevProps.branches.sucess) {
        let sufix = this.props.product.success ? '-ficha-imovel' : ''
        this.setState({
          shBranchId: this.props.branches.codigoFilialPadrao,
          shBranchName: 'Filial Padrão',
          shBranchModalId: this.props.branches.CodigoPadraoIntegracaoEmail + sufix,
        })
      }
    }

    if (prevState.blockSending !== this.state.blockSending) {
      setTimeout(() => {
        this.setState(prevState => {
          const resetBranch = {
            shBranchId: '',
            shBranchName: '',
            branchSelected: '',
            shBranchModalId: '',
            zoneName: '',
          }
          const resetState = {
            name: '',
            email: '',
            phone: '',
            stateInitials: '',
            whatsapp: false,
            nameDirt: false,
            emailDirt: false,
            phoneDirt: false,
            blockSending: false,
            success: '',
            error: '',
            hasBranches: false,
            hasFacilitaMsg: '',
            privacyPolicies: true,
          }
          return prevState.singleFilial ? { ...resetState } : { ...resetState, ...resetBranch }
        })
      }, 3000)
    }

    if (prevProps.region !== this.props.region) {
      let stateList = this.props.regions
      let praca
      if (stateList.success) {
        let busca = await stateList.estados.find(item => item.IdEstado === this.props.region)
        praca = busca.Uf.toLowerCase()
        this.setState({
          stateInitials: `${praca}`,
        })
      }
    }

    const listaFiliaisAtendimento = this.props.branches.listaFiliaisAtendimento
    if (!isEqual(prevState.listaFiliaisAtendimento, listaFiliaisAtendimento)) {
      this.setState({
        listaFiliaisAtendimento: listaFiliaisAtendimento,
        hasListaFiliais: !isEmpty(listaFiliaisAtendimento),
      })
      if (this.state.hasListaFiliais) {
        if (listaFiliaisAtendimento.length === 1) {
          this.setState({ singleFilial: true })
          const item = listaFiliaisAtendimento[0]
          if (this.state.shBranchId !== item.CodigoFilial) {
            this._handleChangeBranch(item)
          }
        } else {
          this.setState({ singleFilial: false })
        }
      }
    }

    if (prevState.shBranchId !== this.state.shBranchId) {
      let dadosFilial = listaFiliaisAtendimento.find(item => item.CodigoFilial === this.state.shBranchId)
      if (!isEmpty(dadosFilial)) {
        if (this.state.shBranchModalId !== dadosFilial.CodigoIntegracaoEmail) {
          let sufix = this.props.product.success ? '-ficha-imovel' : ''
          this.setState({
            shBranchModalId: dadosFilial.CodigoIntegracaoEmail + sufix,
            shBranchName: dadosFilial.Nome,
          })
        }
      }
    }
  }

  _toggleMenu(event) {
    event.preventDefault()
    this.setState({
      showMenuChat: !this.state.showMenuChat,
    })
  }

  _handleChangeBranch(item) {
    const zoneName =  `#loja-${slugify(item.Nome).replace('-', '').toLowerCase()}-modal-email`
    this.setState({ branchSelected: item.Nome, shBranchId: item.CodigoFilial, zoneName })
  }

  _enviaMensagem(element) {
    this.setState({ nameDirt: true, emailDirt: true, blockSending: true })

    let whatsapp = this.state.whatsapp ? 'Prefiro que falem comigo pelo WhatsApp' : ''
    let nome = this.state.name
    let emailValid = TOOLS.emailValid(this.state.email)
    let phoneValid = this.state.phoneDirt ? TOOLS.phoneValid(this.state.phone) : true
    if (nome !== '' && emailValid && phoneValid) {

      let region = this.props.region === undefined
        ? this.props.product.imovel.Localizacao.IdEstado
        : this.props.region

      let values = {
        product: this.props.product.imovel,
        highlight: this.props.highlightModal,
        gaSend: COOKIES.getUtmGaSend(),
        regionId: parseInt(region, 10),
        email: this.state.email,
        nome: this.state.name,
        telefone: this.state.phone,
        idLogFacilita: null,
      }

      const integraSomenteMobi = !!values.product && !isEmpty(values.product)
        ? values.product.IntegraSomenteMobi
        : false

      // São Paulo - Facilita
      if (!integraSomenteMobi && values.regionId === 1) {
        let urlWithoutQuerystring = window.location.href.split('?')[0]

        let nomeCidade = this.props.locations.find(item => item.idEstado === this.props.region)

        let jsonBody = {}
        jsonBody['facilita_custom_page'] = document.title
        jsonBody['facilita_custom_url'] = `${urlWithoutQuerystring}?utm_campaign=${values.gaSend.UtmCampaign}&utm_content=${values.gaSend.UtmContent}&utm_medium=${values.gaSend.UtmMedium}&utm_source=${values.gaSend.UtmSource}&utm_term=${values.gaSend.UtmTerm}${!!values.gaSend.UtmGclid ? `&utm_gclid=${values.gaSend.UtmGclid}` : ''}`
        jsonBody['facilita_custom_selector'] = this.state.shBranchModalId
        jsonBody['name'] = this.state.name
        jsonBody['email'] = this.state.email
        jsonBody['phone'] = this.state.phone
        jsonBody['codigo_filial'] = this.state.shBranchId
        jsonBody['nome_filial'] = this.state.shBranchName
        jsonBody['client_id_ga'] = values.gaSend.CodigoGa
        jsonBody['whatsapp'] = whatsapp
        jsonBody['idImovel'] = undefined
        jsonBody['empreendimento'] = undefined
        jsonBody['cidade'] = nomeCidade.nome
        jsonBody['ImovelOrigemId'] = 3
        jsonBody['url'] = window.location.href
        jsonBody['produto'] = 31
        jsonBody['Zona'] = this.state.zoneName

        if (values.product && values.product.imovelId) {
          jsonBody['idImovel'] = values.product.imovelId
          jsonBody['produto'] = values.product.IdFacilita || 31
          jsonBody['empreendimento'] = values.product.Nome
          jsonBody['cidade'] = values.product.Localizacao.Cidade
        }

        if (values.highlight && values.highlight.imovelId) {
          jsonBody['idImovel'] = values.highlight.imovelId
          jsonBody['produto'] = values.highlight.idFacilita || 31
          jsonBody['empreendimento'] = values.highlight.imovelNome
          jsonBody['cidade'] = values.highlight.imovelLocalizacao
        }

        let logPayload = {
          IdImovelOrigem: 3,
          PontoContato: 7,
          IdentificadorLog: 'E028', //codigo padrão - falha facilita
        }

        this.props.actions.callFacilita(jsonBody).then(responseFacilita => {
          logPayload['Descricao'] = `{ "request": ${JSON.stringify(jsonBody)}, "response": ${JSON.stringify(responseFacilita)} }`
          if (responseFacilita.status === 'success') {
            logPayload['IdentificadorLog'] = 'I023' // codigo - sucesso facilita
          }
        }).catch(erro => {
          logPayload['Descricao'] = `{ "request": ${JSON.stringify(jsonBody)}, "response": ${JSON.stringify(erro)} }`
        }).finally(() => {
          this.props.actions.recordLog(logPayload).then(response => {
            values['idLogFacilita'] = response.idLog
            this._generateLead(values)
          })
        })
      } else {
        this._generateLead(values)
      }
    } else {
      this.setState({ blockSending: false })
    }

    // GA data
    const elementText = slugify(element.target.innerText, { lower: true })
    genericModalDataLayer(this.props.product.imovel, this.props.locations, this.props.region, 'modal-email', elementText)
  }

  _generateLead(values) {
    let jsonBody = {}
    jsonBody['Email'] = values.email
    jsonBody['EstadoId'] = values.regionId
    jsonBody['Nome'] = values.nome
    jsonBody['Telefone'] = values.telefone
    jsonBody['Filial'] = this.state.shBranchId
    jsonBody['WhatsApp'] = this.state.whatsapp
    jsonBody['Praca'] = this.state.stateInitials
    jsonBody['ImovelOrigemId'] = 3
    jsonBody['PontoContato'] = 'Informações por Email'
    jsonBody['url'] = window.location.href
    jsonBody['ip'] = this.props.user.currentIp
    jsonBody['IdLog'] = values.idLogFacilita

    if (values.product && values.product.imovelId) {
      jsonBody['IdImovel'] = values.product.imovelId
      jsonBody['NomeImovel'] = values.product.Nome
    }

    if (values.highlight && values.highlight.imovelId) {
      jsonBody['IdImovel'] = values.highlight.imovelId
      jsonBody['NomeImovel'] = values.highlight.imovelNome
    }

    Object.assign(jsonBody, values.gaSend)

    this.props.actions.contactMessage(jsonBody).then((result) => {
      jsonBody.retorno = result.IdLead
      this.setState({ success: true })
    }).catch(result => {
      this.setState({ error: true })
    }).finally(() => {
      this.setState({
        nameDirt: false,
        emailDirt: false,
        blockSending: false,
      })
      setTimeout(() => {
        this.setState({ error: false, success: false })
        this.props.close()
      }, 5000)
    })
  }


  handleInputChange(event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    this.setState({
      [name]: value,
    })
  }

  render() {
    let nameValid
    let emailValid
    let phoneValid
    let blockSending = this.state.blockSending

    if (this.state.nameDirt) {
      nameValid = (this.state.name !== '') ? 'is-valid' : 'has-error'
    }

    if (this.state.emailDirt) {
      emailValid = (TOOLS.emailValid(this.state.email)) ? 'is-valid' : 'has-error'
    }

    if (this.state.phoneDirt) {
      phoneValid = (TOOLS.phoneValid(this.state.phone)) ? 'is-valid' : 'has-error'
    }

    const listaFiliaisAtendimento = this.state.listaFiliaisAtendimento
    const mostrarListaFiliais = this.state.hasListaFiliais && !this.state.singleFilial

    return <Modal show={this.props.show} close={this.props.close} fullscreen={false} goback={this.props.goback} extraClass='modal-email'>
      <h4 className='h5 mt3 mb2'>
        <strong>
          {+this.props.region !== 1 ? 'Informações via e-mail' : 'Entre em contato'}
        </strong>
      </h4>
      <form
        onSubmit={(event) => this._handleSubmit(event)}
        data-ga-name='modal-contato'
        id={this.state.shBranchModalId}
      >
        <div className={`field-group mb2 ${nameValid === 'is-valid' && 'is-valid'} ${nameValid === 'has-error' && 'has-error'}`}>
          <label>
            <input className='mb0' type='text' value={this.state.name}
            onChange={(event) => this.setState({ name: event.target.value })}
            onBlur={(e) => { handleBlurDatalayer(e, 'name', 'Informações via e-mail'); this.setState({ nameDirt: true }) }}
            placeholder='Qual é seu nome?' maxLength='70' />
            <div className='text-small text-error ml1 mt1'>Qual seu nome?</div>
          </label>
          <span className='icon mr1'>
            <span className='field-icon'>
              <Icon iconType='far' icon='user' size='sm' />
            </span>
            <span className='text-error'>
              <Icon icon='times' size='sm' />
            </span>
            <span className='text-success'>
              <Icon icon='check' size='sm' />
            </span>
          </span>
        </div>
        <div className={`field-group mb2 ${emailValid === 'is-valid' && 'is-valid'} ${emailValid === 'has-error' && 'has-error'}`}>
          <label>
            <input
              className='mb0'
              type='email'
              value={this.state.email}
              onChange={(event) => this.setState({ email: event.target.value })}
              onBlur={(e) => { handleBlurDatalayer(e, 'email', 'Informações via e-mail'); this.setState({ emailDirt: true }) }}
              maxLength='70'
              placeholder='Qual é seu e-mail?'
            />
            <div className='text-small text-error ml1 mt1'>Seu e-mail</div>
          </label>
          <span className='icon mr1'>
            <span className='field-icon'>
              <Icon icon='at' size='sm' />
            </span>
            <span className='text-error'>
              <Icon icon='times' size='sm' />
            </span>
            <span className='text-success'>
              <Icon icon='check' size='sm' />
            </span>
          </span>
        </div>
        <div className={`field-group mb3 ${phoneValid === 'is-valid' && 'is-valid'} ${phoneValid === 'has-error' && 'has-error'}`}>
          <label>
            <MaskedInput
              mask={TOOLS.cellphoneMask(this.state.phone)}
              guide={false}
              className='mb0'
              type='tel'
              value={this.state.phone}
              onChange={(event) => this.setState({ phone: event.target.value })}
              onBlur={(e) => { handleBlurDatalayer(e, 'email', 'Informações via e-mail'); this.setState({ phoneDirt: true }) }}
              placeholder='Qual é o seu telefone (com DDD)?'
            />
            <div className='text-small text-error ml1 mt1'>Seu telefone com DDD</div>
          </label>
          <span className='icon mr1'>
            <span className='field-icon'>
              <Icon icon='phone' size='sm' />
            </span>
            <span className='text-error'>
              <Icon icon='times' size='sm' />
            </span>
            <span className='text-success'>
              <Icon icon='check' size='sm' />
            </span>
          </span>
        </div>

        {mostrarListaFiliais &&
          <div className={'field-group mb3'}>
            <label>
              <div>
                <button className={`branchListButton ${this.state.showMenuChat ? 'active' : ''}`} onClick={(event) => this._toggleMenu(event)}>
                  <span>{this.state.branchSelected ? this.state.branchSelected : 'Selecione a loja mais próxima'}</span>
                </button>
                {this.state.showMenuChat &&
                  <ul className='branchList'>
                    {listaFiliaisAtendimento.map((item, index) => {
                      let siglaEstado = item.siglaEstado.toUpperCase()
                      return (
                        <li key={item.Id} className={this.state.branchSelected === item.Nome ? 'selecionado' : ''}>
                          <button
                            onClick={
                              (event) => {
                                this._toggleMenu(event)
                                this._handleChangeBranch(item)
                              }
                            }
                          >
                            <span className='icon hover hidden'>
                              <Icon icon='check' size='sm' />
                            </span>
                            <span><strong>{item.Nome}</strong></span>
                            <span>{item.Rua}, {item.Numero} - {item.nomeBairro}, {item.nomeCidade} - {siglaEstado}</span>
                          </button>
                        </li>
                      )
                    })}
                  </ul>
                }
              </div>
              <div className='text-small text-error ml1 mt1'>Preencha a loja mais próxima, por favor</div>
            </label>
            <span className='icon mr1'>
              <span className='field-icon'>
                <Icon icon='chevron-down' size='sm' />
              </span>
              <span className='text-error'>
                <Icon icon='times' size='sm' />
              </span>
              <span className='text-success'>
                <Icon icon='check' size='sm' />
              </span>
            </span>
          </div>
        }

        <div className='custom-checkbox'>
          <input id='whatsapp-field1' type='checkbox' checked={this.state.whatsapp} onChange={() => this.setState({ whatsapp: !this.state.whatsapp })} /><label htmlFor='whatsapp-field1'>Prefiro que falem comigo pelo WhatsApp</label>
        </div>

        <div className={'mt3'}>
            <label htmlFor='privacy-field-newsletter'>Prezamos pela privacidade e a coleta dos seus dados pessoais atenderá as diretrizes da legislação aplicável. Para mais informações, acesse nosso{' '}
              <a href='/termos-privacidade' title='Aviso de Privacidade' target='_blank' rel='noreferrer noopener'>Aviso de Privacidade</a>
            </label>
        </div>

        <button className='button info min-width mt4' type='button' disabled={blockSending} onClick={e => this._enviaMensagem(e)} data-ga-status>{blockSending ? 'Enviando...' : 'Solicitar informações'}</button>

        {this.state.success &&
          <div className='callout success text-center mt4 mb0'>
            <p>Suas informações foram enviadas com sucesso.</p>
          </div>
        }
        {this.state.error &&
          <div className='callout alert text-center mt4 mb0'>
            <p>Não foi possível realizar a sua solicitação, tente mais tarde.</p>
          </div>
        }
      </form>
    </Modal>
  }
}
const mapStateToProps = state => {
  return {
    currentUser: state.user.currentUser,
    product: state.products.product,
    region: state.shared.region,
    regions: state.shared.regions,
    highlightModal: state.shared.highlightModal,
    shBranchId: state.shared.shBranchId,
    locations: state.locations.estados,
    branches: state.shared.regionBranches,
    user: state.user,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      ...USER_ACTION,
      ...SHARED_ACTION,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalEmail)



// WEBPACK FOOTER //
// ./src/components/children/contactForm/ModalEmail.js